import AsyncViewFactory from '@/Factories/AsyncViewFactory';
import DetailViewViewModelT from '@/ViewModels/Views/DetailViewViewModel';
import DetailViewViewT from '@/Views/DetailViewView';
import ComponentManager from '@/Management/ComponentManager';
import FrontController from '@/Management/FrontController';

export default class DetailViewViewFactory extends AsyncViewFactory {
    /**
    * Die ID eines Operation-Calls
    */
    public contextID: string;
    public contextParameters: {};
    /**
    * Die Action f�r den Modus der DV
    */
    public action: string;
    /**
    * Der Name des Typs des Objektes in der DV
    */
    public pdTypeName: string;
    public pdoId: number;
    public contextObject: number;
    /**
    * Falls aus einer assoziativen LV ein Objekt erzeugt wird, so steht hier der Typ des Ursprungsobjektes.
    */
    public contextTypeName: string;
    /**
    * Falls aus einer assoziativen LV ein Objekt erzeugt wird, so steht hier der Name der Assoziation.
    */
    public contextRelation: string;
    /**
     * @override
     */
    public viewModel: DetailViewViewModelT;
    public view: DetailViewViewT;
    public serializedFilters: any;
    private DetailViewViewModel = ComponentManager.getViewModel<typeof DetailViewViewModelT>('DetailViewViewModel');
    private DetailViewView = ComponentManager.getView<typeof DetailViewViewT>('DetailViewView');
    private call: any;
    constructor(params: any) {
        super(params);

        // Die folgenden Parameter beziehen sich jeweils nur auf den ersten erzeugten DetailViewContext
        this.contextID = this.paramOrDefault(params.ContextID, null);
        this.contextParameters = this.paramOrDefault(params.ContextParameters, {});
        if (!String.isNullOrEmpty(this.contextID)) {
            this.call = FrontController.getCall(this.contextID);
            if (this.call != null) {
                this.contextParameters = $.extend(true, this.contextParameters, this.call.contextParameters);
            }
        }
        this.action = this.paramOrDefault(params.Action, 'EDIT'); // Wird wohl zur Zeit gar nicht verwendet
        this.pdTypeName = this.paramOrDefault(params.TypeName, '');
        this.pdoId = this.paramOrDefault(params.PdoId, -1);
        this.contextObject = this.paramOrDefault(params.ContextObject, -1);
        this.contextTypeName = this.paramOrDefault(params.ContextTypeName, '');
        this.contextRelation = this.paramOrDefault(params.ContextRelation, '');
        // Kompatibilit�t mit altem Format:
        // Wenn PdoId �bergeben wird, aber eigentlich ContextObject gemeint war, so erkennen wir dies daran,
        // dass folgende Bedingungen alle wahr sind:
        // a) this.pdoId gesetzt
        // b) this.contextObject nicht gesetzt
        // c) this.contextTypeName oder this.contextRelation gesetzt
        if (this.pdoId > 0 && this.contextObject <= 0 && (!String.isNullOrEmpty(this.contextTypeName) || !String.isNullOrEmpty(this.contextRelation))) {
            this.contextObject = this.pdoId;
            this.pdoId = -1;
        }
        this.serializedFilters = {};
        Object.getOwnPropertyNames(params)
            .filter(paramName => paramName.indexOf('SerializedFilter-') > -1)
            .forEach(paramName => {
                this.serializedFilters[paramName.substring('SerializedFilter-'.length)] = params[paramName];
            });
    }

    public getRegion(): string {
        return 'Content';
    }

    public async getElementAsync(): Promise<JQuery> {
        this.resolveDependencies(['Wireframe']);
        if (this.viewModel == null) {
            this.viewModel = new this.DetailViewViewModel({ viewFactory: this, serializedFilters: this.serializedFilters });
        }
        if (this.view == null) {
            const $rootElement = this.createRootElement('DetailView');
            this.view = new this.DetailViewView(this.viewModel, $rootElement);
        }
        this.defineComputed(() => {
            this.setPageTitle(this.viewModel.pageTitle.toString());
        });
        let tuple = await this.view.getTupleAsync();
        return tuple.view;
    }

    public refresh(): boolean {
        if (this.viewModel != null && this.viewModel.isDisposed !== true) {
            let ctx = this.viewModel.currentContext();
            if (ctx != null) {
                ctx.refresh();
                return true;
            }
        }
        return false;
    }
}

ComponentManager.setFactory('DetailView', DetailViewViewFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');